import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M9.91928 2.13803C10.7003 1.35698 11.9667 1.35698 12.7477 2.13803L13.8621 3.25241C14.6431 4.03346 14.6431 5.29979 13.8621 6.08084L12.9429 7.00006L9.00016 3.05735L8.05735 4.00016L12.0001 7.94287L5.66683 14.2761C5.41678 14.5262 5.07764 14.6666 4.72402 14.6666H2.00016C1.63197 14.6666 1.3335 14.3682 1.3335 14V11.2761C1.3335 10.9225 1.47397 10.5833 1.72402 10.3333L9.91928 2.13803Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }